<ng-container *transloco="let t">
    <!-- Не используем bazis-input-default, потому что классы валидности должны быть у родительского контрола -->
    @let required = required$ | async;

    @if (mode === 'input') {
        <div
            [class]="'bazis-control ' + cssClassSizeControl"
            [ngClass]="{
                'bazis-control--focused': isFocused,
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': disabled,
                'bazis-control--dirty': dateValue.dirty,
                'bazis-control--empty': emptyValues.indexOf(dateValue.value) > -1,
            }"
        >
            <ng-container [ngTemplateOutlet]="tplLabel"></ng-container>

            <div
                class="bazis-control__field-group"
                [class.bazis-control__field-group--disabled]="
                    ngControl.control.disabled || disabled
                "
                [class.bazis-control__field-group--focused]="isFocused"
            >
                @if (placeIcon === 'left') {
                    <bazis-control-field-start [icon]="icons.date"> </bazis-control-field-start>
                }

                <ng-container [ngTemplateOutlet]="tplInput"></ng-container>

                <bazis-control-field-end
                    #fieldEnd
                    [icon]="placeIcon === 'right' ? icons.date : ''"
                    [canEraserShow]="hasEraser"
                    [value]="dateValue.value"
                    (erased)="onClear()"
                >
                </bazis-control-field-end>
            </div>

            <ng-container [ngTemplateOutlet]="tplError"></ng-container>
            <ng-container [ngTemplateOutlet]="tplNote"></ng-container>
        </div>
    } @else if (mode === 'picker') {
        <div
            #inputDate
            clickOutside
            (clickOutside)="clickPopperOutside()"
            [excludeElement]="calendar"
        >
            <div
                class="bazis-control"
                [class]="'bazis-control ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--invalid': ngControl.control.invalid,
                    'bazis-control--disabled': disabled,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
                }"
            >
                <ng-container [ngTemplateOutlet]="tplLabel"></ng-container>

                <div
                    class="bazis-control__field-group bh-pointer"
                    [class.bazis-control__field-group--disabled]="
                        ngControl.control.disabled || disabled
                    "
                    (click)="openCalendar($event)"
                >
                    @if (placeIcon === 'left') {
                        <bazis-control-field-start [icon]="icons.date"> </bazis-control-field-start>
                    }

                    <div class="bazis-control__field-wrapper">
                        @if (dateValue.value) {
                            <div class="bazis-control__field">
                                {{ dateValue.value }}
                            </div>
                        } @else {
                            <div class="bazis-control__field bazis-text_placeholder">
                                {{
                                    placeholder
                                        ? placeholder
                                        : placeholderKey
                                          ? t(placeholderKey)
                                          : ''
                                }}
                            </div>
                        }
                    </div>

                    <bazis-control-field-end
                        [icon]="placeIcon === 'right' ? icons.date : ''"
                        [canEraserShow]="hasEraser"
                        [value]="ngControl.control.value"
                        (erased)="onClear()"
                    >
                    </bazis-control-field-end>
                </div>

                <ng-container [ngTemplateOutlet]="tplError"></ng-container>
                <ng-container [ngTemplateOutlet]="tplNote"></ng-container>
            </div>

            <ng-container [ngTemplateOutlet]="tplPopover"></ng-container>
        </div>
    } @else {
        <!-- START MODE MIXED -->
        <div
            #inputDate
            clickOutside
            (clickOutside)="clickPopperOutside()"
            [excludeElement]="calendar"
        >
            <div
                [class]="'bazis-control ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--focused': isFocused,
                    'bazis-control--invalid': ngControl.control.invalid,
                    'bazis-control--disabled': disabled,
                    'bazis-control--dirty': dateValue.dirty || ngControl.control.dirty,
                    'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
                }"
            >
                <ng-container [ngTemplateOutlet]="tplLabel"></ng-container>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--disabled]="
                        ngControl.control.disabled || disabled
                    "
                    [class.bazis-control__field-group--focused]="isFocused"
                >
                    @if (placeIcon === 'left') {
                        <bazis-control-field-start
                            [isClickable]="true"
                            [icon]="icons.date"
                            (actionClick)="openCalendar($event)"
                        >
                        </bazis-control-field-start>
                    }

                    <ng-container [ngTemplateOutlet]="tplInput"></ng-container>

                    <bazis-control-field-end
                        #fieldEnd
                        [isClickable]="placeIcon === 'right'"
                        [icon]="placeIcon === 'right' ? icons.date : ''"
                        [canEraserShow]="hasEraser"
                        [value]="dateValue.value"
                        (erased)="onClear()"
                        (actionClick)="openCalendar($event)"
                    >
                    </bazis-control-field-end>
                </div>

                <ng-container [ngTemplateOutlet]="tplError"></ng-container>
                <ng-container [ngTemplateOutlet]="tplNote"></ng-container>
            </div>

            <ng-container [ngTemplateOutlet]="tplPopover"></ng-container>
        </div>
    }

    <!-- TEMPLATES -->
    <ng-template #tplLabel>
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="required"
        >
            @if (tooltipKey) {
                <bazis-interrogation
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            }
        </bazis-label>
    </ng-template>

    <ng-template #tplInput>
        <div class="bazis-control__field-wrapper">
            <input
                type="text"
                class="bazis-control__field"
                [placeholder]="placeholder ? placeholder : placeholderKey ? t(placeholderKey) : ''"
                (focus)="focusField($event)"
                (blur)="blurField($event)"
                [formControl]="dateValue"
                [mask]="maskSettings.mask"
                [showMaskTyped]="maskSettings.showMaskTyped && isFocused"
                [placeHolderCharacter]="maskSettings.placeHolderCharacter"
                [dropSpecialCharacters]="maskSettings.dropSpecialCharacters"
                [keepCharacterPositions]="maskSettings.keepCharacterPositions"
            />
        </div>
    </ng-template>

    <ng-template #tplError>
        <div class="bazis-control__error">
            <bazis-form-error
                [validationErrorMessages]="validationErrorMessages"
                [formControl]="ngControl.control"
            ></bazis-form-error>

            <ng-container [ngTemplateOutlet]="outsideContentTpl"></ng-container>
            <!-- @if (dateValue.status !== 'INVALID') {
                <bazis-form-error
                    [validationErrorMessages]="validationErrorMessages"
                    [formControl]="ngControl.control"
                ></bazis-form-error>
            } -->
        </div>
    </ng-template>

    <ng-template #tplNote>
        @if (noteKey) {
            <div class="bazis-control__note">
                {{ t(noteKey, noteParams) }}
            </div>
        }
        <ng-content select="note"></ng-content>
    </ng-template>

    <ng-template #tplPopover>
        <div
            #calendar
            class="bh-popper-z-index"
            [hidden]="!showCalendar"
            (click)="clickPopper()"
        >
            @if (showCalendar) {
                <bazis-datepicker
                    [value]="calendarValue"
                    (valueChange)="setValueFromCalendar($event)"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [formatOutput]="displayFormat"
                    [startYear]="startYear"
                    [disabledIntervals]="disabledIntervals"
                    [marks$]="marks$"
                    [viewConfig]="datapickerViewConfig"
                    [visibleAllYears]="visibleAllYears"
                    [canToggleDay]="canToggleDay"
                ></bazis-datepicker>
            }
        </div>
    </ng-template>
    <ng-template #outsideContentTpl><ng-content></ng-content></ng-template>
</ng-container>
